const BASE = 'interchain-dashboard.qualification-texts';

export function getNPSQualificationKey(actual: number | null | undefined): string {
  if (actual == null) return `${BASE}.no-data`;
  if (actual > 65) return `${BASE}.excellent`;
  if (actual >= 50) return `${BASE}.good`;
  if (actual >= 35) return `${BASE}.regular`;
  if (actual >= 20) return `${BASE}.bad`;
  return `${BASE}.very-bad`;
}

export function getIROQualificationKey(value: number | null | undefined): string {
  if (value == null) return `${BASE}.no-data`;
  if (value > 90) return `${BASE}.excellent`;
  if (value >= 80) return `${BASE}.good`;
  if (value >= 70) return `${BASE}.regular`;
  if (value >= 60) return `${BASE}.bad`;
  return `${BASE}.very-bad`;
}

export function getCasesQualificationKey(value: number | null | undefined): string {
  if (value == null) return `${BASE}.no-data`;
  if (value > 95) return `${BASE}.excellent`;
  if (value >= 90) return `${BASE}.good`;
  if (value >= 80) return `${BASE}.regular`;
  if (value >= 70) return `${BASE}.bad`;
  return `${BASE}.very-bad`;
}

export type AutomationRateQualification = 'excellent' | 'good' | 'regular' | 'bad' | 'very_bad' | 'no_data';

export function getAutomationRateLevel(rate: number | null | undefined): AutomationRateQualification {
  if (rate == null) return 'no_data';
  if (rate > 40) return 'excellent';
  if (rate >= 20) return 'good';
  if (rate >= 10) return 'regular';
  if (rate >= 5) return 'bad';
  return 'very_bad';
}
